import { Component, OnInit } from '@angular/core';
import { CreditCardService } from '@bari/core/services/credit-card.service';
import { BaseModalService } from '@shared/modal/services/base-modal.service';

@Component({
  selector: 'bari-travel-success-modal-module',
  templateUrl: './travel-success-modal.component.html',
  styleUrls: ['./travel-success-modal.component.scss']
})
export class TravelSuccessModalComponent implements OnInit {

  public busy = true;
  public countries: [];
  public error = {
    hasError: false,
    message: ''
  };

  // URL: travel-success-modal
  constructor(private _service: CreditCardService, private _modal: BaseModalService) { }

  public async putTravelMode() {
    await this._service.putTravelMode();
  }

  public close() {
    this._modal.close();
  }

  async ngOnInit() {
    try {
      this.countries = await this._service.getCountry();
    } catch (e) {
      this.error = {
        hasError: true,
        message: 'Não foi possível buscar as taxas'
      };
    } finally {
      this.busy = false;
    }
  }

}
